import {getArrowTemplate} from './getArrowTemplate.js';

export function sectionCarousel() {
  $('.section-carousel').each(function () {
    let
      section = $(this),
      wrapArrows = section.find('.carousel-arrows'),
      wrapDots = section.find('.carousel-dots'),
      progressLine = $('<s></s>'),
      setProgress = function (currentSlideIndex) {
        let
          dots = wrapDots.find('li'),
          dotsLength = dots.length;

        if (dotsLength) {
          progressLine.css('width', 100 / dotsLength * (currentSlideIndex + 1) + '%');
        }
      };

    wrapDots.append(progressLine);

    section.find('.carousel').on('init', function () {
      setProgress(0);
    }).slick({
      infinite: false,
      adaptiveHeight: true,
      // autoplay: false,
      mobileFirst: true,
      //appendDots: _this,
      prevArrow: `<button type="button" class="slick-arrow slick-prev">${getArrowTemplate()}</button>`,
      nextArrow: `<button type="button" class="slick-arrow slick-next">${getArrowTemplate()}</button>`,
      appendArrows: wrapArrows,
      appendDots: wrapDots,
      responsive: [
        {
          breakpoint: 1199,
          settings: {
            slidesToShow: 4,
            dots: true
          }
        }, {
          breakpoint: 767,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 567,
          settings: {
            slidesToShow: 2
          }
        }
      ]
    }).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
      setProgress(nextSlide);
    });
  });
}


// WEBPACK FOOTER //
// ./assets/js/modules/sectionCarousel.js